/**
* @ngdoc directive
* @name Unique Field
*
* @element input
*
* @description
  Validate if value in the field is unique
*
* @scope
* @param {Array} list - of objects to compare value
* @param {String} field - name of field in list to compare with ngModel value
* @param {Number} id - item id
*
* @example
  <div ng-init='caption = "1"'>
  <input type="text" class="form-control"
    ng-model="caption"
    placeholder="Name"
    maxlength="50"

    unique-field
    list='[{ name: "1", id: 1 }, { name: "2", id: 2 }]'
    field='name'
    />
  </div>
*/

(function() {
  'use strict';

  app.directive('uniqueField', directive);

  function directive() {
    return {
      scope: {
        list: '=',
        field: '@',
        id: '=?',
        hasInstantList: '=?'
      },
      require: 'ngModel',
      restrict: 'A',
      link: link,
      priority: 100
    };

    function link($scope, $element, $attributes, ngModel) {
      var getValue, instantList;
      var props = $scope.field.split('.');

      if ($scope.hasInstantList) {
        instantList = angular.copy($scope.list);
        instantList.pop();
      }


      init();

      $scope.$watch('list', function(first, second){
        ngModel.$valid = ngModel.$validators.isUnique(ngModel.$modelValue);
      })

      function init() {
        getValue = props.length > 1 ? getValueDeep : getValueRegular;
        ngModel.$validators.isUnique = $scope.id ? isUniqueById : isUnique;
      }

      function getList() {
        return $scope.hasInstantList ? instantList : $scope.list;
      }

      function isUnique(modelValue) {
        return !_.find(getList(), function (item) {
          return getValue(item) === modelValue;
        });
      }

      function isUniqueById(modelValue) {
        return !_.find(getList(), function (item) {
          return getValue(item) === modelValue && $scope.id !== item.id;
        });
      }

      function getValueDeep(item) {
        var value = item;
        _.forEach(props, function (prop) {
          value = value[prop];
        });
        return value;
      }

      function getValueRegular(item) {
        return item[$scope.field];
      }
    }
  }
}());



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/uniqueField.js